var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-50 flex flex-col h-screen"},[_c('TopNavigationBar',{staticClass:"bg-white w-full h-[60px]"}),_c('div',{staticClass:"flex justify-between",staticStyle:{"height":"calc(100vh - 60px)"}},[_c('LeftSideBar'),_c('router-view',{staticClass:"h-full flex-grow overflow-y-auto p-4 md:p-10"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }